export default __webpack_public_path__ + "static/media/howItWorksStep3.b766aa99.svg";